import React, { memo, useMemo } from "react";
import { Container } from "@pixi/react";
import { Settings, GAME_LAYOUT } from "../../settings";
import RoyalCollectOverlayReel from "./RoyalCollectOverlayReel";
import { useReelRefs } from "../../Contexts/ReelRefsContext";

/**
 * RoyalCollectOverlayReelSet
 *
 * Container for all Royal Collect overlay reels.
 * Manages spine animations for coin symbols across all reels.
 * Mirrors HoldAndWinOverlayReelSet pattern.
 *
 * Always visible (background animation handles viewport shifting).
 */
const RoyalCollectOverlayReelSet = memo(
  ({ symbolWidth, symbolHeight, reelSpacing }) => {
    const { royalCollectOverlayReelRefs } = useReelRefs();

    const containerY = useMemo(
      () => -symbolHeight * (0.5 * Settings.SYMBOLS_VISIBLE - 0.5),
      [symbolHeight],
    );

    return (
      <Container name="royal_collect_overlay" zIndex={9} y={containerY}>
        {GAME_LAYOUT.REEL_INDICES.map((index) => (
          <RoyalCollectOverlayReel
            key={index}
            symbolHeight={symbolHeight}
            symbolWidth={symbolWidth}
            reelSpacing={reelSpacing}
            ref={(el) => {
              royalCollectOverlayReelRefs.current[index] = el;
            }}
            index={index}
          />
        ))}
      </Container>
    );
  },
);

RoyalCollectOverlayReelSet.displayName = "RoyalCollectOverlayReelSet";

export default RoyalCollectOverlayReelSet;
